import OpCascader from "./index.vue";
var opcascader = {
  install: function install(Vue) {
    Vue.component("OpCascader", OpCascader);
  }
};
export default opcascader;